import {MatIcon} from '@angular/material/icon';
import {ChangeDetectionStrategy, Component, TemplateRef, ViewChild} from '@angular/core';
import {RectangularButtonContentContext} from '@aviary/buttons/button.types';
import {NgTemplateOutlet} from '@angular/common';

@Component({
  selector: 'mx-rectangular-button-content',
  templateUrl: './rectangular-button-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, NgTemplateOutlet]
})
export class RectangularButtonContentComponent {
  @ViewChild('content', {static: true}) public content: TemplateRef<RectangularButtonContentContext>;
}
